import { render } from "./CardDetailView.vue?vue&type=template&id=0abe168f&scoped=true&ts=true"
import script from "./CardDetailView.vue?vue&type=script&lang=ts"
export * from "./CardDetailView.vue?vue&type=script&lang=ts"

import "./CardDetailView.vue?vue&type=style&index=0&id=0abe168f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abe168f"]])

export default __exports__